import { Router } from "express";

import { semesterEnrollmentController } from "../controllers/semester-enrollment-controller";
import {
  authenticate,
  createRateLimit,
  requireEmailVerification,
} from "../middleware/auth-middleware";

const router = Router();

// Environment-aware rate limiting
const generalRateLimit = createRateLimit.general(); // 50 req/5min (prod) | unlimited (dev)

/**
 * @route   GET /api/v1/school/semesters/enrollment
 * @desc    Get all school semesters with enrollment statistics
 * @access  Private (School Admin)
 * @query   academicYear, status, isActive, page, limit, sortBy, sortOrder
 */
router.get(
  "/enrollment",
  authenticate,
  requireEmailVerification,
  generalRateLimit,
  (req, res) =>
    semesterEnrollmentController.getAllSemestersWithEnrollment(req, res),
);

/**
 * @route   GET /api/v1/school/semesters/current
 * @desc    Get current semester with active enrollments
 * @access  Private (School Admin)
 */
router.get(
  "/current",
  authenticate,
  requireEmailVerification,
  generalRateLimit,
  (req, res) => semesterEnrollmentController.getCurrentSemester(req, res),
);

/**
 * @route   GET /api/v1/school/semesters/past
 * @desc    Get past semesters (completed)
 * @access  Private (School Admin)
 * @query   academicYear, page, limit, sortBy, sortOrder
 */
router.get(
  "/past",
  authenticate,
  requireEmailVerification,
  generalRateLimit,
  (req, res) => semesterEnrollmentController.getPastSemesters(req, res),
);

/**
 * @route   GET /api/v1/school/semesters/:id/courses
 * @desc    Get semester courses with enrollment details
 * @access  Private (School Admin)
 * @query   status, subject, teacherId, page, limit, sortBy, sortOrder
 */
router.get(
  "/:id/courses",
  authenticate,
  requireEmailVerification,
  generalRateLimit,
  (req, res) => semesterEnrollmentController.getSemesterCourses(req, res),
);

/**
 * @route   GET /api/v1/school/semesters/:id/enrollment-summary
 * @desc    Get semester enrollment summary with comprehensive statistics
 * @access  Private (School Admin)
 */
router.get(
  "/:id/enrollment-summary",
  authenticate,
  requireEmailVerification,
  generalRateLimit,
  (req, res) =>
    semesterEnrollmentController.getSemesterEnrollmentSummary(req, res),
);

export default router;
